import React, { useMemo } from 'react'
import { useSelector } from 'react-redux';
import LogoHe from '../../../assests/logo-new.png';
import LogoAr from '../../../assests/logo-newar.png';
import classes from './Logo.module.css';

const Logo = ({ className }) => {

    const { texts, lang } = useSelector(state => state.translate);
    const titleImgs = useMemo(() => ({ he: { logo: LogoHe }, ar: { logo: LogoAr } }), [])

    return <div className={`${classes.Logo} ${className}`}>
        <img alt={texts.logoText} src={titleImgs[lang]?.logo} />
    </div>
}
export default Logo;